import { Collapse } from "antd";
import React, { useEffect, useState } from "react";
import GetApiCall from "../../helpers/GetApi";
import GetSeoData from "../../helpers/GetSeoData";
import "./Faq.css";

import { createPortal } from "react-dom";

const SchemaMarkup = () => {
    const schemaData = {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        "mainEntity": [
            {
                "@type": "Question",
                "name": "Where is Ruby Foods situated? How is the delivery made to distributors at various locations?",
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Ruby Foods is situated near Mattuthavani Bus Stand, Madurai, Tamilnadu. It’s at SIPCO Gate II that’s opposite Poo Market. Free transportation and door delivery are offered to distributors irrespective of where they are in the state of Tamilnadu. Delivery details including the driver’s contact number and date of delivery will be presented well in advance."
                }
            },
            {
                "@type": "Question",
                "name": "What are the products available with Ruby Foods?",
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "The products available with Ruby Foods are\nRuby Badam\nRuby Rose\nRuby Pista\nRuby Cashew\nRuby Jigarthanda\nCoffee Shot\nRuby Fruit Drink – Mango (This product comes with a high margin for distributors)\nMilkee Badam"
                }
            },
            {
                "@type": "Question",
                "name": "What is the margin a distributor may gain?",
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "The margin varies with products.\nA margin of 10% to 20% is offered to distributors.\nA margin of 30% is offered to retailers."
                }
            },
            {
                "@type": "Question",
                "name": "What are the terms and conditions for damages and spoilage during delivery?",
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Our products in PET bottles come with a 6-month guarantee and those in glass bottles come with a 3-month guarantee. Despite that, damages and spoilage in products are dealt with with utmost consideration by Ruby Foods. We ensure that such items are replaced properly along with the order for the next set of products."
                }
            },
            {
                "@type": "Question",
                "name": "Should I deposit any amount of money initially to become a distributor?",
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Ruby Foods does not demand any deposit of money normally. Only if the initial order is on products that come in glass bottles, we claim a payment of Rs.100 per case (Rs. 2 per bottle) as a deposit. The deposit will be refunded when the distributor withdraws purchasing glass bottles and submits the used bottles. There is no complicated process ordering for products. Just a phone call will initiate the dispatch of items."
                }
            },
            {
                "@type": "Question",
                "name": "How much should I invest to become a distributor?",
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Ruby Foods practices an investment plan of Rs. 25,000 or a minimal order of 50 grades with the distributors. The orders may increase based on the movement of the products."
                }
            },
            {
                "@type": "Question",
                "name": "How frequently will the stock be provided?",
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Our customer care will contact you every week and collect your requirements. Upon placing the order, you will receive the products within 2 days. All the necessary details regarding the dispatch will also be communicated to you duly."
                }
            },
            {
                "@type": "Question",
                "name": "Is it Cash-on-delivery or Credit system that Ruby Foods follows for distributors?",
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "We follow a Cash-on-delivery system and do not encourage Credits. After three initial transactions, we encourage fund transfers only through bank accounts as the formal statement of proof becomes available for both parties."
                }
            },
            {
                "@type": "Question",
                "name": "Does Ruby Foods possess/provide executives for distributors to promote sales?",
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "If Ruby Foods has been practicing a good level of marketing in that particular area using its representatives/executives, the dealer will be provided with them. If it is considered to be a ‘Vacant’ area where representatives/executives hadn’t been operating till then, Ruby Foods will just wait for a decent number of dealers to rise in that area and then allocate representatives/executives promptly.\nWe also provide posters and stickers to help the dealers market our products and achieve sales in their areas."
                }
            },
            {
                "@type": "Question",
                "name": "What are the quality assurance certificates owned by Ruby Foods?",
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Ruby Foods has been formally approved and accredited by FSSAI and ISO. We have been functioning for the last 58 years and our customer feedback speaks volumes of our invincible quality.\nNote: We do not add preservatives to any of our products."
                }
            },
            {
                "@type": "Question",
                "name": "How many dealers does Ruby Foods currently have?",
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Ruby Foods operates with around 500 dealers in Tamilnadu currently. Around 100 dealers among them have been operating with us for over 10 years. We have also expanded our market into Karnataka, Andhra Pradesh, and Kerala in recent days."
                }
            },
            {
                "@type": "Question",
                "name": "Will Ruby Foods install more than one dealer in a specific area?",
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "We do not install more than one dealer in a geographic area. There may be cases when two dealers who operate with different sets of our products operate in the same area. However, when a dealer is handling all the products of Ruby Foods, he will not find another dealer in his area. Ruby Foods is very particular on this point."
                }
            },
            {
                "@type": "Question",
                "name": "Which product of Ruby Foods has the largest sales in the market?",
                "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Our flavored milk products and Mango (1/2 liter) have the highest selling rate in the market."
                }
            }
        ]
    };

    return createPortal(
        <script type="application/ld+json">
            {JSON.stringify(schemaData)}
        </script>,
        document.body // injects directly into <body>
    );
};
export default function Faq() {
    const [Faq, setFaq] = useState([]);
    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
        GetApiCall.getRequest("GetFAQS").then((results) => {
            results.json().then((obj) => {
                if (results.status == 200 || results.status == 201) {
                    setFaq(obj.data)
                }
            });
        });
    }, [])
    return (
        <>
            <SchemaMarkup />
            <div className="blank-section px-lg-3">
                <GetSeoData type="Faq" id={null} />
                <div className="container-fluid">
                    <div className="row section-padding py-4 disclaimer-box">
                        <div className="heading-style mb-3">
                            <h1 className="main-heading mb-0">
                                FAQ's
                            </h1>
                            <h3 className="mb-0">We have answered few of the commonly asked questions</h3>
                        </div>

                        <div className="col-md-12">
                            {Faq?.map((data) => {
                                return (
                                    <Collapse
                                        items={[
                                            {
                                                key: data.fld_id,
                                                label: <h6 className="mb-0">{data.fld_question}</h6>,
                                                children: data.fld_answer,
                                            },
                                        ]}
                                    >
                                    </Collapse>
                                );
                            })}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}